// PATIENT DOCUMENT HANDLING
import usePatientDoc from '../../../hooks/usePatientDoc';
import { PatientDoc, IndexScreenCardPayload } from '@usacsmideo/types';
import { getValidScreenArray } from '../../../data/navigation/getValidScreenArray';
// import Ionicons from '@expo/vector-icons/Ionicons';

// DISPLAY ELEMENTS
import IndexScreenCardLink from './IndexScreenCardLink';

export default function IndexScreenCard(payload: IndexScreenCardPayload) {
  const { patientId, currentPath, youWill, specialInstructions } = payload;
  const patientDoc = usePatientDoc(patientId);
  const patientInfo = patientDoc?.data as PatientDoc;

  if (!patientInfo || !patientInfo.navObj) {
    return <p>Loading...</p>;
  }
  // CONVERT THE NAVOBJ TO A VALIDATED, SORTED ARRAY OF SCREENS
  const navArray = getValidScreenArray(patientInfo.navObj, 'IndexScreenCard');

  // FIND THE CURRENT SCREEN IN THE NAVOBJ
  const currentScreen = navArray.find(
    (screen) => screen.path === currentPath.slice(1), // SLICE TO REMOVE THE LEADING SLASH
  );

  if (!patientInfo) {
    return <p>Loading...</p>;
  }

  if (!currentScreen) {
    return <p>Unable to determine section to generate content for IndexScreenCard.tsx. Please notify support.</p>;
  }

  return (
    <div
      style={{
        backgroundColor: currentScreen.activeBackgroundColor,

        padding: 10,
        borderRadius: 10,
      }}
    >
      <div
        style={{
          flexDirection: 'row',
          // paddingLeft: 10,
          justifyContent: 'space-between',
          paddingBottom: 10,
          marginBottom: 10,
          borderBottomColor: currentScreen.id === 'cardIndex' ? 'black' : 'white',
          borderBottomWidth: 2,
        }}
      >
        <p
          style={{
            fontWeight: 'bold',
            fontSize: 26,
            color: currentScreen.id === 'cardIndex' ? 'black' : 'white',
            marginLeft: 10,
          }}
        >
          {currentScreen.displayName}
        </p>
        {/* <Ionicons
          name={currentScreen.icon as keyof typeof Ionicons.glyphMap}
          size={24}
          color={currentScreen.disabled ? "gray" : "white"}
        /> */}
      </div>
      <div style={{ marginBottom: 10 }}>
        <p
          style={{
            // fontStyle: "italic",
            textDecorationLine: 'underline',
            color: currentScreen.id === 'cardIndex' ? 'black' : 'white',
            fontWeight: 'bold',
            fontSize: 22,
          }}
        >
          In this section you will
        </p>
        {youWill?.length > 0 &&
          youWill.map((goal: string, index: number) => (
            <p
              key={index}
              style={{
                color: currentScreen.id === 'cardIndex' ? 'black' : 'white',
                fontSize: 20,
              }}
              className="my-2"
            >
              - {goal}
            </p>
          ))}
        {specialInstructions && (
          <div>
            <p
              style={{
                marginTop: 10,
                fontStyle: 'italic',
                color: 'white',
                fontSize: 18,
              }}
            >
              {specialInstructions}
            </p>
          </div>
        )}
      </div>

      <div style={{ marginBottom: 10 }}>
        <p
          style={{
            textDecorationLine: 'underline',
            color: currentScreen.id === 'cardIndex' ? 'black' : 'white',
            fontWeight: 'bold',
            fontSize: 22,
          }}
        >
          Your Section Progress
        </p>
      </div>
      {/* ITERATE OVER THE NAVOBJ TO FIND SCREENS IN THIS SECTION
      THEN GENERATE A LINK ELEMENT TO EACH ONE WHERE PARENT IS SECTION INDEX ID
      USE THE SCREEN.COMPLETED TO REGISTER A CHECK MARK FOR COMPLETED SCREENS */}
      <div className="flex flex-col">
        {navArray
          // BUILD THE DISPLAYED STEP LIST FIRST SO STEP NUMBERS ARE CONTIGUOUS (1..N)
          // OVER ONLY THE SCREENS ACTUALLY RENDERED IN THIS SECTION.
          .filter(
            (screen) =>
              (screen.parent !== 'self' && // HIDE THE INDEX SCREEN
                screen.section === currentScreen.section && // ONLY SHOW SCREENS IN THE SAME SECTION
                screen.disabled === false) || // HIDE DISABLED SCREENS
              // OK TO SHOW THESE 'DISABLED' SCREENS
              (screen.section === currentScreen.section &&
                screen.disabled === true &&
                (screen.id === 'finalSignatures' || screen.id === 'recording')),
          )
          .map((screen, index) => (
            <IndexScreenCardLink key={screen.id} screen={screen} stepNumber={index + 1} />
          ))}
      </div>
      <p
        style={{
          color: currentScreen.id === 'cardIndex' ? 'black' : 'white',
          fontSize: 16,
          fontStyle: 'italic',
          textAlign: 'center',
        }}
      >
        Tap on a section item above to view/complete it...
      </p>
      <p
        style={{
          color: currentScreen.id === 'cardIndex' ? 'black' : 'white',
          fontSize: 16,
          fontStyle: 'italic',
          textAlign: 'center',
        }}
      >
        ...or tap the button below to continue.
      </p>
    </div>
  );
}
